import React, {useState} from "react";
import {IMenuItem, MenuItemType} from "modules/types";
import {useSelector} from "react-redux";
import {isAuthedSelector} from "modules/selectors";
import chevronIcon from "assets/img/icons/chevron.svg";
import {partial, get} from "lodash";
import externalIcon from "assets/img/icons/external.png";
import {
	WrapperMobile,
	DropdownItemMobile,
	NavItemMobile,
	NavItemMobileExternal,
} from "components/Navigation/items/MenuItemMobile";
import {SignUp} from "components/Navigation/items/SignUp";

interface IProps {
	item: IMenuItem;
	isSub?: boolean;
	onLinkClick: (link: string) => void;
}

export const MobileItem: React.FC<IProps> = ({item, isSub, onLinkClick}) => {
	const isAuthed = useSelector(isAuthedSelector);
	const [isOpen, setIsOpen] = useState(false);
	const isHideItem = (targetItem: IMenuItem) => !isAuthed && targetItem.isAuthed;
	const mobileLink = get(item, "mobileLink", item.link);

	if (item.menuItemType === MenuItemType.SignUp) {
		if (isAuthed) {
			return null;
		}
		return <SignUp item={item} isMobile={true} />;
	}

	return (
		<React.Fragment>
			<WrapperMobile isHideItem={isHideItem(item)} isSub={isSub}>
				{
					{
						[MenuItemType.Link]: item.subItems ? (
							<React.Fragment>
								<DropdownItemMobile isOpen={isOpen} onClick={partial(setIsOpen, !isOpen)}>
									{window.getTranslations(item.label)}
									<img src={chevronIcon} alt="Chevron Icon" />
								</DropdownItemMobile>
							</React.Fragment>
						) : (
							<NavItemMobile onClick={partial(onLinkClick, mobileLink)} to={mobileLink}>
								{window.getTranslations(item.label)}
							</NavItemMobile>
						),
						[MenuItemType.External]: (
							<NavItemMobileExternal
								onClick={partial(onLinkClick, item.link)}
								href={item.link}
								target={"_blank"}
								rel="noopener noreferrer"
							>
								{window.getTranslations(item.label)}
								<img src={externalIcon} alt={"External Icon"} />
							</NavItemMobileExternal>
						),
						[MenuItemType.SignUp]: null,
					}[item.menuItemType]
				}
			</WrapperMobile>
			{item.subItems &&
				isOpen &&
				item.subItems.map((subItem) => (
					<MobileItem onLinkClick={onLinkClick} item={subItem} key={subItem.label} isSub={true} />
				))}
		</React.Fragment>
	);
};
